import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import {Select} from '@stubhub/bamboo';

import '../styles/SmartSelect.scss';

const SmartSelect = ({className, options, value, labelText, disabled, id, ...otherProps}) => {
  // If there's only one option, render as text-only
  if (options?.length === 1) {
    const [singleOption] = options;
    const displayValue = singleOption.label || singleOption.value;

    return (
      <div className={cs('SmartSelect', 'SmartSelect--text-only', className)} data-testid={id}>
        {labelText && <div className="SmartSelect__label">{labelText}</div>}
        <div className="SmartSelect__text-value">{displayValue}</div>
      </div>
    );
  }

  // If there are multiple options or no options, render the normal Select component
  return (
    <Select
      id={id}
      className={cs('SmartSelect', 'SmartSelect--select', className)}
      options={options}
      value={value}
      labelText={labelText || ''}
      disabled={disabled}
      {...otherProps}
    />
  );
};

SmartSelect.propTypes = {
  /** Unique identifier for the select element */
  id: PropTypes.string,

  /** CSS class name */
  className: PropTypes.string,

  /** Array of options for the select. Each option should have 'value' and 'label' properties */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string,
    })
  ),

  /** Currently selected value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Label text for the select */
  labelText: PropTypes.string,

  /** Whether the select is disabled */
  disabled: PropTypes.bool,

  /** onChange handler */
  onChange: PropTypes.func,
};

export default SmartSelect;
